import { Message } from "element-ui"
import { initOssClient } from "@/utils/aliOss"
import { getUserPri } from "@/api/project/project"

let requestFnMap = {
  SET_OSS_Client: initOssClient,
  SET_Project_Permission: getUserPri
}

export function getBundleFns({ commit, mutation, id } = {}) {
  if (!id) {
    let setFn = dataObj => {
      commit(mutation, {
        status: dataObj.status,
        data: dataObj.data,
        lastReqTime: dataObj.lastReqTime
      })
    }
    let resetFn = () => commit(mutation, { status: "Null", data: null })
    let pendingFn = () => commit(mutation, { status: "Pending", data: null })
    return { setFn, resetFn, pendingFn, requestFn: requestFnMap[mutation] }
  } else {
    let setFn = dataObj => {
      commit(mutation, {
        dataObj: { status: dataObj.status, data: dataObj.data, lastReqTime: dataObj.lastReqTime },
        id
      })
    }
    let resetFn = () => commit(mutation, { dataObj: { status: "Null", data: null }, id })
    let pendingFn = () => commit(mutation, { dataObj: { status: "Pending", data: null }, id })
    return { setFn, resetFn, pendingFn, requestFn: requestFnMap[mutation] }
  }
}

function requestData({ requestFn, pendingFn, setFn, resetFn }, params = []) {
  pendingFn()
  return requestFn(...params).then(res => {
    let { code, msg, data } = res.data
    if (code === undefined) data = res.data
    if ((code === undefined || code === 0) && data) {
      setFn({
        status: "Finished",
        data,
        lastReqTime: Date.now(),
        refresh: true
      })
      return Promise.resolve(data)
    }
    Message.error(msg || "请求出错，请重试")
    resetFn()
    return Promise.reject("数据获取失败，请刷新重试！")
  })
}

export function waitForData(dataObj, bundleFnObj, ...params) {
  // status: ["Null", "Pending", "Finished"]
  switch (dataObj.status) {
    case "Null": {
      return requestData(bundleFnObj, params)
    }
    case "Pending": {
      return new Promise((resolve, reject) => {
        let count = 10
        let timer = setInterval(() => {
          if (--count < 0) {
            clearInterval(timer)
            bundleFnObj.resetFn()
            return reject("数据获取失败，请刷新重试！")
          }
          if (dataObj.status == "Finished") {
            clearInterval(timer)
            return resolve(dataObj.data)
          }
        }, 600)
      })
    }
    case "Finished": {
      if (dataObj.expires == "infinite") return Promise.resolve(dataObj.data)
      if ((Date.now() - dataObj.lastReqTime) / 1000 > dataObj.expires)
        return requestData(bundleFnObj, params)
      return Promise.resolve(dataObj.data)
    }
  }
}
